import React from "react";
import { Form } from "react-bootstrap";
import Names from "../form/Names";
import SSN from "../form/SSN";

export default function OwnerInformation(props) {
  return (
    <>
      <h5>Owner information</h5>
      <Names id="owner" onChange={props.onChange} state={props.state} />
      <Form.Group controlId="ownerSuffixName">
        <Form.Label>Suffix Name (optional)</Form.Label>
        <Form.Control
          as="select"
          onChange={props.onChange}
          value={props.state.ownerSuffixName}
        >
          <option value="">Please Select</option>
          <option value="DDS">DDS</option>
          <option value="MD">MD</option>
          <option value="PhD">PhD</option>
          <option value="JR">JR</option>
          <option value="SR">SR</option>
          <option value="I">I</option>
          <option value="II">II</option>
          <option value="III">III</option>
          <option value="IV">IV</option>
          <option value="V">V</option>
          <option value="VI">VI</option>
        </Form.Control>
      </Form.Group>
      <Form.Group controlId="ownerTitle">
        <Form.Label>Title</Form.Label>
        <Form.Control
          required
          as="select"
          onChange={props.onChange}
          value={props.state ? props.state.ownerTitle : ""}
        >
          <option value="">Please Select</option>
          <option value="ceo">CEO</option>
          <option value="executor">Executor</option>
          <option value="owner">Owner</option>
          <option value="managing member">Managing Member</option>
          <option value="managing member/owner">Managing Member/Owner</option>
          <option value="president">President</option>
          <option value="other">Other</option>
        </Form.Control>
        <Form.Control.Feedback type="invalid">
          Please select a valid title
        </Form.Control.Feedback>
      </Form.Group>
      <SSN id="owner" state={props.state} onChange={props.onChange} />
    </>
  );
}
